import React, { useState } from 'react';
import { BORDER_RADIUS } from '../../../styled';
import AdapexOrGPTSlot from '../../common/AdapexOrGPTSlot';
const AdBoxGridDesktop = ({ params, appContext }) => {
    const { app_id, page_url } = params;
    const { ad_settings } = appContext.publisherClient || {};
    const [rendered, setRendered] = useState(true);
    const slotProps = {
        appContext,
        params,
        app_id: app_id !== null && app_id !== void 0 ? app_id : '',
        id: 'div-21796380238-fwn-widget-grid-desktop',
        page_url: page_url !== null && page_url !== void 0 ? page_url : '',
        path: `/21796380238/${app_id}`,
        size: (ad_settings === null || ad_settings === void 0 ? void 0 : ad_settings.grid_desktop_size) || [[728, 90]],
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gridColumn: '1 / -1',
            gridRow: '3',
            borderRadius: BORDER_RADIUS,
            overflow: 'hidden',
            margin: '0 auto',
            textAlign: 'center',
        },
        targeting: [
            ['app_id', [app_id !== null && app_id !== void 0 ? app_id : '']],
            ['page_url', [page_url !== null && page_url !== void 0 ? page_url : '']],
        ],
        onError: () => setRendered(false),
    };
    return rendered ? <AdapexOrGPTSlot {...slotProps}/> : null;
};
export default AdBoxGridDesktop;
